import { createStore } from 'effector'
import type { UiPaymentInfo } from './index.h'

export const $uiPaymentInfo = createStore<UiPaymentInfo | null>(null)
